module.exports = __webpack_public_path__ + "media/images/athletes/499-63cf9290770a26d5be5bf30027fab35a.png";